import React from 'react';
import StockConversionForm from './StockConversionForm';

const NewStockConversionPage = () => {
    return <StockConversionForm formType="create" currentConversionId={null} />;
};

export default NewStockConversionPage;